export enum LinkedDataErrorCodes {
    General = 0,
    FetchDataError = 1
}

export interface ILinkedDataError {
    developerMessage: string;
    errorCode: LinkedDataErrorCodes;
    stackTrace: string;
}
